import { useEffect, useRef } from 'react';

const AnimatedStripes = ({
  stripeCount = 3,
  stripeWidth = 250,
  opacity = 0.3,
  speed = 1,
  blur = 20,
  gap = 200,
  direction = 'left-to-right',
  darkMode = false,
}) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');

    let animationFrameId;
    let time = 0;

    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };

    const stripes = [];

    const initStripes = () => {
      stripes.length = 0;
      for (let i = 0; i < stripeCount; i++) {
        stripes.push({
          x: -stripeWidth + i * (stripeWidth + gap),
          y: 0,
          width: stripeWidth,
          height: canvas.height,
          speed: speed,
        });
      }
    };

    const draw = () => {
      time++;

      if (darkMode) {
        ctx.fillStyle = '#050816';
      } else {
        ctx.fillStyle = '#F8FAFC';
      }
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      stripes.forEach((stripe) => {
        stripe.x += stripe.speed;

        const totalCycle = stripeCount * (stripeWidth + gap);
        if (stripe.x > canvas.width) {
          stripe.x = stripe.x - totalCycle;
        }

        ctx.save();
        ctx.filter = `blur(${blur}px)`;
        ctx.fillStyle = `rgba(255, 255, 255, ${opacity})`;
        ctx.fillRect(stripe.x, stripe.y, stripe.width, stripe.height);
        ctx.restore();
      });

      animationFrameId = requestAnimationFrame(draw);
    };

    resizeCanvas();
    initStripes();
    draw();

    window.addEventListener('resize', resizeCanvas);

    return () => {
      cancelAnimationFrame(animationFrameId);
      window.removeEventListener('resize', resizeCanvas);
    };
  }, [stripeCount, stripeWidth, opacity, speed, blur, gap, darkMode]);

  return (
    <canvas
      ref={canvasRef}
      className="fixed inset-0 w-full h-full pointer-events-none"
    />
  );
};

export default AnimatedStripes;